<template>
<div class="main situation">
    <!--<div class="maskTitle">-->
    <!--<span>案件详情</span>-->
    <!--<span @click="closeMask"><i class="el-icon-close"></i></span>-->
    <!--</div>-->
    <div style="height: 100%">
        <div class="leftContent">
            <el-collapse v-model="activeNamesFirst">
                <el-collapse-item title="单位信息" name="1">
                    <el-form ref="unitData" :model="unitData" :rules="rules">
                        <div class="tableContent">
                            <div class="row-item h-49">
                                <div class="row">
                                    <div class="column">
                                        <div class="left">
                                            <div>所属区域</div>
                                        </div>
                                        <div class="right h32">
                                            <el-select placeholder="请选择" v-model="provinceData" style="width: 100%">
                                                <!-- <el-option
                            v-for="item in provinceData"
                            :key="item.id"
                            :label="item.label"
                            :value="item.id"
                          > -->
                                                </el-option>
                                            </el-select>
                                            <el-select placeholder="请选择" style="width: 100%" v-model="cityData">
                                                <!-- <el-option
                            v-for="item in cityData"
                            :key="item.id"
                            :label="item.label"
                            :value="item.id"
                          > -->
                                                </el-option>
                                            </el-select>
                                            <el-select ref="selectLabel" placeholder="请选择" style="width: 100%" v-model="unitData.areaId" @change="areaLabel">
                                                <el-option :key="null" :label="'全部'" :value="0"></el-option>
                                                <el-option v-for="item in areaData" :key="item.id" :label="item.areaName" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row-item h-49">
                                <div class="row">
                                    <div class="column">
                                        <div class="left">
                                            <div><i class="required">*</i>单位全称</div>
                                        </div>
                                        <div class="right h32">
                                            <el-form-item prop="fullName">
                                                <el-input placeholder="请输入单位全称" v-model="unitData.fullName"></el-input>
                                            </el-form-item>
                                            <!-- <input
                          class="input"
                          type="text"
                          placeholder="请输入单位全称"
                        /> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row-item h-49">
                                <div class="row">
                                    <div class="column">
                                        <div class="left">
                                            <div><i class="required">*</i>单位简称</div>
                                        </div>
                                        <div class="right h32">
                                            <el-form-item prop="simpName">
                                                <el-input placeholder="请输入单位简称" v-model="unitData.simpName"></el-input>
                                            </el-form-item>
                                            <!-- <input
                          class="input"
                          type="text"
                          placeholder="请输入单位简称"
                        /> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row-item h-49">
                                <div class="row">
                                    <div class="column">
                                        <div class="left">
                                            <div><i class="required">*</i>组织机构编码</div>
                                        </div>
                                        <div class="right h32">
                                            <el-form-item prop="organizationCode">
                                                <el-input placeholder="请输入组织机构编码" v-model="unitData.organizationCode"></el-input>
                                            </el-form-item>
                                            <!-- <input
                          class="input"
                          type="text"
                          placeholder="请输入组织机构编码"
                        /> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row-item h-49">
                                <div class="row">
                                    <div class="column">
                                        <div class="left">
                                            <div>报警编号前缀</div>
                                        </div>
                                        <div class="right h32">
                                            <input class="input" type="text" placeholder="请输入报警编号前缀" v-model="unitData.accidentNoPrefix" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row-item h-49">
                                <div class="row">
                                    <div class="column">
                                        <div class="left">
                                            <div>排序号</div>
                                        </div>
                                        <div class="right h32">
                                            <input class="input" type="text" placeholder="请输入排序号" v-model="unitData.indexNo" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row-item h-100">
                                <div class="row">
                                    <div class="column">
                                        <div class="left">
                                            <div>备注</div>
                                        </div>
                                        <div class="right h32">
                                            <el-input type="textarea" placeholder="请输入备注" v-model="unitData.desc" maxlength="120" resize="none" show-word-limit>
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="activeNamesThird">
                <el-collapse-item title="图章上传" name="1">
                    <div class="wholeAcccindentClass">
                        <div class="accidentImages">
                            <div class="images">
                                <div class="img-box">
                                    <div v-if="unitData.stampUrl" style="width:100%;height:100%;">
                                        <div class="video-wrap" v-if="/(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(unitData.stampUrl)">
                                            <i></i>
                                        </div>
                                        <img :src="getImageUrl(unitData.stampUrl,'')" alt="" @click="previewImg(unitData.stampUrl)" />
                                    </div>
                                    <div class="img-mask-no" v-else>
                                        <i class="el-icon-upload" v-if="!unitData.stampUrl"></i>
                                        <i class="el-icon-zoom-in" @click="previewImg(unitData.stampUrl)" v-else></i>
                                        <div v-if="!unitData.stampUrl">上传图片</div>
                                    </div>
                                </div>
                                <el-upload ref="upload" class="upload-demo" :action="action" :auto-upload="false" :headers="headers" :show-file-list="false" :on-change="handleChange" :before-upload="beforeAvatarUpload" :on-success="uploadSuccess">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="activeNamesFourth">
                <!--<el-collapse-item title="水印上传" name="1">
                    <div class="wholeAcccindentClass">
                        <div class="accidentImages">
                            <div class="images">
                                <el-upload ref="uploadImg" action="#" :http-request="uploadMark" list-type="picture-card" :show-file-list="false" :before-upload="beforeAvatarUpload">
                                    <i v-if="!unitData.watermarkUrl" class="el-icon-upload">
                                    </i>
                                    <img v-if="unitData.watermarkUrl" :src="unitData.watermarkUrl" class="avatar" />
                                </el-upload>

                                <el-button size="small" type="primary" @click="uploadImgFn('mark')">点击上传</el-button>
                            </div>
                        </div>
                    </div>
                </el-collapse-item>-->
                <el-collapse-item title="水印上传" name="1">
                    <div class="wholeAcccindentClass">
                        <div class="accidentImages">
                            <div class="images">
                                <div class="img-box">
                                    <div v-if="unitData.watermarkUrl" style="width:100%;height:100%;">
                                        <div class="video-wrap" v-if="/(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(unitData.watermarkUrl)">
                                            <i></i>
                                        </div>
                                        <img :src="getImageUrl(unitData.watermarkUrl,1)" alt="" @click="previewImg(unitData.watermarkUrl)" />
                                    </div>
                                    <div class="img-mask-no" v-else>
                                        <i class="el-icon-upload" v-if="!unitData.watermarkUrl"></i>
                                        <i class="el-icon-zoom-in" @click="previewImg(unitData.watermarkUrl)" v-else></i>
                                        <div v-if="!unitData.watermarkUrl">上传图片</div>
                                    </div>
                                </div>
                                <el-upload ref="uploadMark" class="upload-demo" :action="actionWatermarkUrl" :auto-upload="false" :headers="headers" :show-file-list="false" :on-change="handleChangeMark" :before-upload="beforeAvatarUpload" :on-success="uploadSuccessMark">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
    <div class="bottomBtns">
        <el-button @click="saveUnitData('unitData')" type="primary">保存</el-button>
        <el-button @click="closeMask" plain>返回</el-button>
    </div>
    <!--<transition name="el-zoom-in-center">-->
    <!--<management v-if="manageShow" @hideManageMask="hideManageMask"></management>-->
    <!--</transition>-->
    <!--<transition name="el-zoom-in-center">-->
    <!--<approvalEdit v-if="approvalShow" @hideApprovalMask="hideApprovalMask"></approvalEdit>-->
    <!--</transition>-->
</div>
</template>

<script>
import config from "@/common/env.js";
// import management from './components/claim-manage'
// import approvalEdit from './components/approval-edit'
export default {
    name: 'claim-detail',
    data() {
        return {
            headers: {
                "TR-TOKEN": JSON.parse(localStorage.getItem('userinfos')).token
            },
            action: '',
            actionWatermarkUrl: '',
            activeNamesFirst: ['1'],
            activeNamesThird: ['1'],
            activeNamesFourth: ['1'],
            testImg: '',
            accidentImg: '',
            value: 3.7,
            manageShow: false,
            approvalShow: false,
            climateList: [],
            textarea: '',
            areaData: null,
            provinceData: "吉林省",
            cityData: "长春市",
            // unitData: {
            //   accidentNoPrefix: "in in",
            //   cityId: "minim irure",
            //   cityName: "sit ipsu",
            //   areaId: 123,
            //   areaName: null,
            //   createId: -42001452.658343874,
            //   createTime: -20882880.793420494,
            //   desc: "nostrud ullamco",
            //   fullName: null,
            //   id: -58909892.738112554,
            //   indexNo: -69917568.68470924,
            //   organizationCode: "pariatur",
            //   provinceId: "Lorem proident ea nostrud ex",
            //   provinceName: "nisi dolor deserunt",
            //   simpName: "dolor nostrud",
            //   stampUrl: "nisi esse a"
            // },
            // ,
            // 必填验证
            rules: {
                fullName: [{
                    required: true,
                    message: '该项内容不能为空',
                    trigger: 'blur',
                }],
                simpName: [{
                    required: true,
                    message: '该项内容不能为空',
                    trigger: 'blur',
                }],
                organizationCode: [{
                    required: true,
                    message: '该项内容不能为空',
                    trigger: 'blur',
                }]
            },
            imageUrl: '',
            dialogImageUrl: '',
            succSava: false,
            myHeader: {
                token: null
            }

        }
    },
    props: {
        detailShow: true,
        unitData: null
    },
    components: {
        // management,
        // approvalEdit

    },
    mounted() {
        this.action = this.CODE_SERVER + '/admin/user/uploadFile'; //图片上传地址
        this.actionWatermarkUrl=this.CODE_SERVER + '/admin/user/no/uploadFile';
        this.getAreaList();
        this.provinceData = this.configuration.provinceData;
        this.cityData = this.configuration.cityData;
    },
    beforeDestroy() {
      localStorage.removeItem('single');
    },
    methods: {
        getImageUrl(url, type) {
            let str = type ? "/file/server/file" : "/file/server/decrypt/file";
            return `${config.baseUrl}${str}?path=${encodeURI(url)}`;
        },
        handleChange(file) {
            console.log(file)
            // console.log(this.val.id)
            // if(this.uploadState) return
            // if (this.val.id == null) return this.$message.error("请先保存基本信息")
            // if(this.model.policeStampUrl != null) return this.$message.error("最多只能上传1个文件")
            this.$refs.upload.submit();
        },
        handleChangeMark(file) {
            console.log('file',file)
            // console.log(this.val.id)
            // if(this.uploadState) return
            // if (this.val.id == null) return this.$message.error("请先保存基本信息")
            // if(this.model.policeStampUrl != null) return this.$message.error("最多只能上传1个文件")
            this.$refs.uploadMark.submit();
        },
        uploadSuccess(res, file) {
            console.log('re88', res)
            if (res.data) {
                this.unitData.stampUrl = res.data.imgUrl;
                this.unitData.url = res.data.url;
            }
        },
        uploadSuccessMark(res, file) {
            console.log('re88', res)
            if (res.data) {
                // this.unitData.watermarkUrl = res.data.imgUrl;
                this.$set(this.unitData,'watermarkUrl',res.data.imgUrl)
                console.log('unitData.watermarkUrl',this.unitData.watermarkUrl)
            }
        },
        // 点击上传图片按钮
        uploadImgFn(arg) {
            if (arg) {
                this.$refs.uploadImg.$children[1].handleClick()
            } else {
                this.$refs.uploadImg.$children[0].handleClick()
            }
        },
        closeMask() {
            this.$emit('detailShowData', false)
            // 保存成功点击返回刷新列表
        },
        hideManageMask() {
            this.manageShow = false
        },
        hideApprovalMask() {
            this.approvalShow = false
        },
        previewImg(url) {
            let that = this;
            if (this.$store.state.previewImgUrl) {
                this.$store.commit("SHOW_PREVIEW_IMG", '')
            }
            let data = []
            if(this.unitData.stampUrl){
              data.push(this.unitData.stampUrl);
            }
            if(this.unitData.watermarkUrl){
                localStorage.setItem('single', 1);
              data.push(this.unitData.watermarkUrl);
            }
            let myIndex=data.findIndex(res=>res==url);
            setTimeout(() => {
                localStorage.setItem('myIndex', myIndex);
                localStorage.setItem('myPics', JSON.stringify(data));
                that.$store.commit('SHOW_PREVIEW_IMG', url)
            }, 1000);
        },
        previewImg1(url) {
          let that=this;
            if(this.$store.state.previewImgUrl){
              this.$store.commit("SHOW_PREVIEW_IMG", '')
            }
            setTimeout(() => {
              that.$store.commit("SHOW_PREVIEW_IMG", url);
            }, 500);
        },
        // 获取省市区三联数据
        getAreaList() {
            this.$axios.get('/admin/organization/areaList').then(res => {
                let data = this.AppUtils.checkResponse(res)
                if (data) {
                    this.areaData = data.data
                }
            })
        },
        areaLabel(val) {
            let obj = {}
            obj = this.areaData.find((item) => { //遍历list的数据
                return item.id === val //筛选出匹配数据
            })
            if (obj) {
                this.unitData.areaName = obj.areaName ? obj.areaName : null
            } else {
                this.unitData.areaName = '全部'
            }
        },
        // 图片限制和提示
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || 'image/png' || 'image/jpg'
            const isLt2M = file.size / 1024 / 1024 < 2

            if (!isJPG) {
                this.$message.error('上传图片只支持jpg、jpeg、png格式!')
            }
            if (!isLt2M) {
                this.$message.error('图片大小不能超过2MB！')
            }
            return isJPG && isLt2M
        },
        // 自定义图片上传
        upload(fileObj) {
            const formData = new FormData()
            formData.append('file', fileObj.file)
            formData.append('type', fileObj.file.type)
            this.$axios.request({
                url: '/admin/user/uploadFile',
                method: 'post',
                data: formData
            }).then(res => {
                if (res) {
                    // this.fileList = []
                    // this.formData = new window.FormData()
                    this.unitData.stampUrl = res.data.data.imgUrl;
                    this.unitData.url = res.data.data.url;
                    console.log(res.data.code)
                }
            })
        },
        //水印上传
        uploadMark(fileObj) {
            const formData = new FormData()
            formData.append('file', fileObj.file)
            formData.append('type', fileObj.file.type)
            this.$axios.request({
                url: '/admin/user/uploadFile',
                method: 'post',
                data: formData
            }).then(res => {
                if (res) {
                    this.unitData.watermarkUrl = res.data.data.imgUrl
                    console.log(res.data.code)
                }
            })
        },
        // 保存
        saveUnitData(formName) {
            let formData = {}
            if (!this.unitData.isNew) {
                formData.id = this.unitData.id
            }
            formData.areaId = this.unitData.areaId,
                formData.areaName = this.unitData.areaName,
                formData.fullName = this.unitData.fullName,
                formData.simpName = this.unitData.simpName,
                formData.organizationCode = this.unitData.organizationCode,
                formData.accidentNoPrefix = this.unitData.accidentNoPrefix,
                formData.indexNo = this.unitData.indexNo,
                formData.desc = this.unitData.desc,
                formData.stampUrl = this.unitData.url,
                formData.watermarkUrl = this.unitData.watermarkUrl
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let url = this.unitData.isNew ? 'save' : 'edit' // 切换新建和保存接口地址
                    this.$axios.post('/admin/organization/' + url, formData).then(res => {
                        let data = this.AppUtils.checkResponse(res)
                        if (data) {
                            // this.$emit('detailShowData', false) //关闭浮层
                            // this.dataTabel = data.data.list
                            // this.$emit('getUnitList') //重新加载列表数据
                            this.succSava = true
                            this.$emit('getUnitList')
                            this.$emit('detailShowData', false)
                            this.$message.success("保存成功")
                        }
                    })
                } else {
                    this.$message.error("必填内容不能为空")
                    return false
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.main {
    display: flex;
    background: #fff;
    flex-direction: row;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    z-index: 100;
    flex-direction: column;
    box-sizing: border-box;

    .maskTitle {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        /*position: fixed;*/
        /*top: 50px;*/
        justify-content: space-between;
        width: calc(100%);
        box-sizing: border-box;
        padding: 10px;
        background: #ccc;
        z-index: 100;
    }

    .leftContent {
        /*height: 100%;*/
        /*overflow-y: scroll;*/
        box-sizing: border-box;
        text-align: left;
        width: calc(100%);
        margin-right: 10px;
        float: left;
        padding-bottom: 50px;

        .tableContent {
            margin-top: 10px;
            border: 1px solid #f4f5f7;
        }

        .userImages {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-top: 20px;

            .img-box {
                margin-right: 10px;
                margin-bottom: 10px;
            }
        }

        .wholeAcccindentClass {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;

            .accidentImages {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .images {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    flex-direction: column;
                    height: 120px;
                    margin-top: 20px;
                    margin-right: 10px;
                    margin-bottom: 10px;

                    .img-box {
                        margin: 0 auto;
                        margin-bottom: 10px;
                    }
                }
            }
        }
    }

    .personInfo {
        .title {
            line-height: 40px;
            background: #ccc;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0px 10px;
        }

        .wholePersonClass {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;

            .accidentImages {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .images {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    flex-direction: column;
                    height: 120px;
                    margin-top: 20px;
                    margin-right: 10px;
                    margin-bottom: 10px;

                    .img-box {
                        margin: 0 auto;
                        margin-bottom: 10px;
                    }
                }
            }
        }
    }

    .bottomBtns {
        width: 100%;
        position: fixed;
        left: 0px;
        bottom: 0px;
        background: #ccc;
        margin-bottom: 0px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

// 修改默认样式
.el-form-item {
    margin-bottom: 0;

    .el-input {
        width: 200px;
    }

    .el-input+div {
        position: absolute;
        top: 30%;
        left: 210px;
    }

    /deep/.el-form-item__error {
        position: absolute;
        top: 30%;
        left: 210px;
    }
}

/deep/.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

/deep/.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

/deep/.avatar-uploader,
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    text-align: center;
}

/deep/.avatar-uploader-icon svg {
    margin-top: 64px;
    /* (178px - 28px) / 2 - 1px */
}

/deep/.avatar {
    width: 145px;
    height: 145px;
    display: block;
}

.el-collapse-item__content {
    height: 200px !important;

    .el-button {
        margin-top: 10px;
    }
}

.wholeAcccindentClass .el-icon-zoom-in:before {
    content: none;
}
</style>



// WEBPACK FOOTER //
// detail.vue?3ab142f9